<template>
  <div class="d-flex mt-2  board">
    <!-- <pre>
    {{ steps }}
    </pre> -->
    <div
      v-for="(step, index) in steps"
      :key="step.id"
      class="ml-1 font-weight-bolder mb-50 flex-grow-1 py-1 text-white rounded fs-0-8vw steps"
    >
      <div class="d-flex justify-content-between align-items-start">
        <h6 class="ml-1 font-weight-bolder">
          {{ step.title[$i18n.locale].toUpperCase() }}
        </h6>
        <b-badge
          v-if="step.sales_bpm_count"
          :variant="step.color"
          class="mr-1 text-white"
        >
          {{ step.sales_bpm_count }}
        </b-badge>
      </div>

      <VuePerfectScrollbar
        class="board-body p-50"
        @ps-y-reach-end="addCards(step)"
      >
        <draggable
          :list="step.lids"
          ghost-class="ghost-card"
          group="cards"
          class="cursor-move mb-0 draggableCards drag"
          :data-stepId="step.id"
          :data-idx="index"
          @end="dragHandler($event, step, index)"
        >

          <div
            v-for="lid in step.lids"
            :key="lid.id"
            :data-lidId="lid.id"
          >
            <b-card
              no-body
              class="d-flex flex-column justify-content-between p-1 my-50"
              @click="toDatailPage(lid.id)"
            >

              <div class="text-secondary">
                <div
                  class="mt-25"
                  style="margin-left: 2px"
                >
                  <feather-icon
                    icon="PocketIcon"
                    class=""
                    style="margin-bottom: 3px;"
                    size="15"
                  />
                  <small class="ml-25 fs-0-8vw font-weight-bold">{{ lid.client.title }}</small>
                </div>
              </div>
              <template
                v-if="lid.product.length"
              >
                <div
                  v-for="product in lid.product"
                  :key="product.id"
                  class="mt-50 mb-2"
                >
                  <!-- <b-badge
                    v-for="p in lid.product"
                    :key="p.id"
                    class="mr-50"
                    variant="warning"
                  >
                    {{ p }}
                  </b-badge> -->
                  <div
                    class="d-flex justify-content-between mt-50 text-success"
                  >
                    <span class="">{{ $t('kanban.apartment_number') }}</span>
                    <div class="border-dotted-bottom mb-25 mx-25 flex-grow-1" />
                    <span class="ml-auto">{{ product.flat_number }}</span>
                  </div>
                  <div
                    class="d-flex justify-content-between mt-50 text-success"
                  >
                    <span class="">{{ $t('kanban.numbers_room') }}</span>
                    <div class="border-dotted-bottom mb-25 mx-25 flex-grow-1" />
                    <span class="ml-auto">{{ product.rooms_count }}</span>
                  </div>
                  <div
                    class="d-flex justify-content-between mt-50 text-success"
                  >
                    <span class="">{{ $t('kanban.numbers_room') }}</span>
                    <div class="border-dotted-bottom mb-25 mx-25 flex-grow-1" />
                    <span class="ml-auto">{{ product.total_area }} м²</span>
                  </div>
                </div>
              </template>

              <h4 class="text-primary font-weight-bolder">
                {{ currencyFormatter(lid.amount) }}
              </h4>

              <div class="task-footer d-flex justify-content-between mb-1 align-items-end">
                <small class="text-secondary">
                  <feather-icon
                    icon="FeatherIcon"
                    size="14"
                    class="text-secondary"
                  />
                  {{ dateFormater(lid.modified_date) }}
                </small>
                <div class="demo-inline-spacing">
                  <feather-icon
                    v-if="lid.comment_count"
                    icon="MessageSquareIcon"
                    size="14"
                    class="text-secondary"
                    :badge="lid.comment_count"
                    badge-classes="badge-secondary"
                  />

                  <feather-icon
                    v-if="lid.attachments_count"
                    icon="PaperclipIcon"
                    size="14"
                    class="text-secondary"
                    :badge="lid.attachments_count"
                    badge-classes="badge-secondary"
                  />
                </div>
              </div>

              <hr class="mb-25">

              <div
                v-if="lid.manager"
                class="d-flex align-items-center"
              >
                <b-avatar
                  v-if="!lid.manager.photo"
                  button
                  variant="primary"
                  :text="lid.manager.first_name"
                  class="align-baseline"
                />
                <!-- :text="lid.manager.last_name.slice(0, 1) + lid.manager.first_name.slice(0, 1)" -->
                <b-avatar
                  v-else
                  class="align-baseline"
                  :src="lid.manager.photo.file"
                />
                <span class="ml-50 text-primary">{{ lid.manager.last_name }} {{ lid.manager.first_name }}</span>
              </div>

            </b-card>
          </div>
        </draggable>
      </VuePerfectScrollbar>
    </div>
  </div>
</template>

<script>
import {
  BAvatar,
  BCard,
  BBadge,
} from 'bootstrap-vue'
import { mapGetters, mapActions } from 'vuex'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import draggable from 'vuedraggable'
import { format } from 'date-fns'

export default {
  components: {
    BAvatar,
    BCard,
    VuePerfectScrollbar,
    draggable,
    BBadge,
  },
  props: ['filter'],
  data() {
    return {
      settings: {},
      pagination: {},
      steps: [],
    }
  },
  computed: {
    ...mapGetters('kanban', ['getKanbanCardsList', 'getCrmStepsList']),
    getLang() {
      return this.$i18n.locale || 'ru'
    },
  },
  watch: {
    'filter.manager': {
      handler() {
        // console.log(231)
        this.refresh(this.filter)
      },
    },
    'filter.search': {
      handler() {
        this.refresh(this.filter)
      },
    },
  },
  methods: {
    ...mapActions('kanban', ['FETCH_CRM_STEPS', 'FETCH_KANBAN_CARDS_LIST', 'UPDATE_ONE_LID']),
    async addCards({ id, sales_bpm_count }) {
      const { page, page_size, count } = this.pagination[id]

      if (count > page * page_size) {
        if (sales_bpm_count <= 3) {
          const response = await this.FETCH_KANBAN_CARDS_LIST({ current_step: id, page: 1, page_size })
          this.steps.forEach((step, index) => {
            if (step.id === id) {
              this.steps[index].lids = [
                ...response.data.results,
              ]
            }
          })
          this.pagination[id].page = 1
          this.pagination[id].count = response.data.count
        } else {
          const response = await this.FETCH_KANBAN_CARDS_LIST({ current_step: id, page: page + 1, page_size })

          this.steps.forEach((step, index) => {
            if (step.id === id) {
              this.steps[index].lids = [
                ...this.steps[index].lids,
                ...response.data.results,
              ]
            }
          })
          this.pagination[id].page += 1
          this.pagination[id].count = response.data.count
        }
      }
    },
    async dragHandler(event, step, idx) {
      const stepIdTo = event.to.dataset.stepid
      const index = event.to.dataset.idx
      const stepIdFrom = event.from.dataset.stepid
      const lidId = event.clone.dataset.lidid

      if (stepIdTo === stepIdFrom) {
        return
      }

      await this.UPDATE_ONE_LID({
        id: lidId,
        data: {
          current_step: stepIdTo,
        },
      })

      this.steps[idx].sales_bpm_count -= this.steps[idx].sales_bpm_count
      this.steps[parseInt(index, 10)].sales_bpm_count += 1

      if (step.lids.length < 1) {
        this.pagination[step.id].page = 0
        this.addCards({ id: step.id, sales_bpm_count: 2 })
      }
    },
    dateFormater(date) {
      return format(new Date(date), 'HH:mm, d.MMM.yy')
    },
    toDatailPage(id) {
      this.$router.push(`/kanban/${id}`)
    },
    refresh(filter) {
      this.steps = this.getCrmStepsList.results

      this.steps.forEach(async step => {
        this.pagination[step.id] = {
          page: 1,
          page_size: 3,
          count: 0,
        }

        const response = await this.FETCH_KANBAN_CARDS_LIST({
          current_step: step.id, page_size: 3, page: 1, ...filter,
        })
        this.pagination[step.id].count = response.data.count

        this.steps = this.steps.map(step2 => {
          let obj = { ...step2 }

          if (step.id === step2.id) {
            obj = {
              ...obj,
              lids: response.data.results,
            }
          }
          return obj
        })
      })
    },
    currencyFormatter(sum) {
      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'UZS',
      })

      return formatter.format(sum)
    },

  },

}
</script>

<style lang="scss" scoped>
.scroll-area {
  position: relative;
  margin: auto;
  width: auto;
  height: auto;
}

.ghost-card {
  opacity: 0.5;
  background: #F7FAFC;
  border: 1px solid #4299e1;
}

.steps {
    background: #E9E9E9;
    width: 250px;
}

.board {
    width: 100%;
    overflow-x: auto ;
}

.board-body {
    width: 250px;
    overflow-y: scroll;
    height: 65vh;
}

.board-body::-webkit-scrollbar-track
{
  border-radius: 6px;
  background-color: #F5F5F5;
}

.board-body::-webkit-scrollbar
{
  width: 1px;
  background-color: #F5F5F5;
}

.board-body::-webkit-scrollbar-thumb
{
  max-width: 4px;
  border-radius: 6px;
  background-color: #d1d2d4;
}

.drag {
    height: 100vh;
}
</style>
